<template>
<div class="verificate-wrap">
    <div class="code-wrap" :class="{mb: mb}">
        <input class="input code" :class="{mb: mb, changeb: code}" type="text" :placeholder="$t($loginLangPrefix('userSign.inputCode'))" v-model="code" @keyup.enter="next()" @input="codeInput" />
        <div class="codeimg" :class="{mb: mb, count: countState}" @click="verification()">{{ countState ? `${count}s` : $t($loginLangPrefix('userSign.getCode')) }}</div>
    </div>
</div>
</template>
<script>
import util from '@utils/util';
import logreg from '../js/logreg';
import api from '../js/api';

export default {
    name: 'verificatewrap',
    props: {
        mb: { type: String, default: '' },
        name: { type: String, default: '' },
        itc: { type: String, default: '' },
        imgCode: { type: String, default: '' },
        type: { type: Number, default: 4 }
    },
    data() {
        return {
            code: '',
            codeError: '',
            count: 60,
            countState: false
        };
    },
    components: {
    },
    methods: {
        codeInput() {
            if (!this.code) {
                this.codeError = this.$t(this.$loginLangPrefix('userSign.codeError'));
            } else if (logreg.validate(this.code, 'phone')) {
                this.codeError = '';
            } else {
                this.codeError = this.$t(this.$loginLangPrefix('userSign.codeError'));
            }
            this.$emit('changeCode', this.code);
            this.$emit('changeCodeError', this.codeError);
        },
        verification() {
            if (!this.imgCode) {
                this.$emit('changeImgCodeError', this.$t(this.$loginLangPrefix('userSign.codeError')));
                return;
            }
            if (!this.countState && this.imgCode) {
                this.countState = true;
                this.countDown();
                api.sendRegCode(this.name, this.itc, this.imgCode, this.type).then((data) => {
                    if (data.ret === '1') {
                        // 验证码发送成功
                    } else {
                        this.codeError = this.$t(this.$loginLangPrefix('userSign.codeSendError'));
                        this.$emit('changeCodeError', this.codeError);
                        this.$emit('changeImgCodeValue');
                    }
                }).catch((response) => {
                    this.$emit('changeCodeError', this.codeError);
                    this.$emit('changeImgCodeValue');
                    if (response.errorMessageTMXTip) {
                        return;
                    }
                    this.codeError = this.$t(this.$loginLangPrefix('userSign.codeSendError'));
                });
                util.KEWLSensorTrack({ lmweb_clickText: '获取验证码' });
            }
        },
        countDown() {
            let num = 60;
            let timer = null;
            if (!timer) {
                timer = setInterval(() => {
                    num -= 1;
                    this.count = num;
                    if (this.count === 0) {
                        clearInterval(timer);
                        this.countState = false;
                        this.count = 60;
                        timer = null;
                    }
                }, 1000);
            }
        },
        next() {
            this.$emit('btnSure');
        }
    },

    // watch: {
    //     // codeError(val) {
    //     //     this.$emit('changeCodeError', val);
    //     // }
    // },

    beforeMount() {
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.verificate-wrap {
    div, input {
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        outline: none;
        border: 0;
        line-height: 1;
    }
    form {
        display: inline;
    }
    .input {
        border-bottom: 1px solid #E3E3E3;
        font-size:16px;
        font-family: 'RobotoRegular';
        font-weight: normal;
        color:rgba(23,23,23,1);
        padding-bottom: 5px;
        box-sizing: border-box;
        &.mb {
            border-bottom: rem(1) solid #E3E3E3;
            padding-bottom: rem(5);
        }
    }
    .code-wrap {
        position: relative;
        width: 100%;
        font-size: 0;
        margin-top: 25px;
        &.mb {
            margin-top: rem(25);
        }
        .code {
            display: inline-block;
            width: 210px;
            vertical-align: bottom;
            margin-right: 10px;
            padding-right: 30px;
            &.mb {
                width: rem(210);
                margin-right: rem(10);
                padding-right: rem(30);
            }
            &.changeb {
                border-bottom: 1px solid #9D1DFF;
            }
        }
        .codeimg {
            position: absolute;
            cursor: pointer;
            right: 0;
            bottom: 0;
            padding: 0 10px;
            box-sizing: border-box;
            display: inline-block;
            // width: 98px;
            min-width: 98px;
            height: 32px;
            border-radius:16px;
            border:1px solid rgba(157,29,255,1);
            vertical-align: bottom;
            font-size:16px;
            font-family: 'RobotoRegular';
            font-weight: normal;
            color:rgba(157,29,255,1);
            line-height:32px;
            text-align: center;
            &.mb {
                // width: rem(98);
                min-width: rem(98);
                padding: 0 rem(10);
                height: rem(32);
                border-radius: rem(16);
                border:rem(1) solid rgba(157,29,255,1);
                line-height: rem(32);
            }
            &.count {
                background:rgba(224,224,224,1);
                border:1px solid rgba(224,224,224,1);
                color:rgba(171,171,171,1);
            }
        }
    }
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color:rgba(181,181,181,1);
    }
    ::-moz-placeholder { /* Firefox 19+ */
        color:rgba(181,181,181,1);
    }
    :-ms-input-placeholder { /* IE 10+ */
        color:rgba(181,181,181,1);
    }
    :-moz-placeholder { /* Firefox 18- */
        color:rgba(181,181,181,1);
    }
}

</style>
